import mvtHeader from '../../../common/components/mvtheader/mvt-header.vue';
import mvtFooter from '../../../common/components/mvtfooter/mvt-footer.vue';
import mvtShifter from '../../../common/components/mvtshifter/mvt-shifter.vue';
import mvtNearby from '../../../common/components/mvtnearby/mvt-nearby.vue';
import mvtNewMap from '../../../common/components/mvtnewmap/mvt-newmap.vue';
import mvtBreadcrumb from '../../../common/components/mvtbreadcrumb/mvt-breadcrumb.vue';
import mvtDialogCenter from '@/common/components/mvtdialogcenter/mvt-dialogcenter.vue';
import mvtPopSignin from '@/common/components/mvtpopsignin/mvt-popsignin.vue';
import enJSON from '../../../common/utilities/lang/en/searchstate.js';
import esJSON from '../../../common/utilities/lang/es/searchstate.js';

import { mapGetters } from 'vuex';
export default {
    name: 'pageSearchState',
    inject: ['$eventBus'],
    components: {
        mvtHeader,
        mvtFooter,
        mvtNewMap,
        mvtShifter,
        mvtNearby,
        mvtBreadcrumb,
        mvtDialogCenter,
        mvtPopSignin,
    },
    computed: {
        ...mapGetters('glb', ['glb']),
        ...mapGetters('searchState', ['getCities', 'getCounties', 'getSeo', 'getNearbyHomes']),
        getBoundaryIndexId() {
            if (this.geoBoundaryIndexId) {
                return this.geoBoundaryIndexId;
            }
            return `state-${this.glb.geo.stateCode}`;
        },
        getTopCities() {
            return this.getCities.slice(0, 10);
        },
        center() {
            if (this.geoLat && this.geoLng) {
                return { lat: this.geoLat, lng: this.geoLng };
            } else {
                return { lat: this.glb.geo.lat, lng: this.glb.geo.lng };
            }
        },
        zoom() {
            if (this.geoLat && this.geoLng) {
                return 12;
            } else {
                return 7;
            }
        },
    },
    data() {
        return {
            loadMap: false,
            showAllCities: false,
            showAllCounties: false,
            geoBoundaryIndexId: '',
            geoLat: null,
            geoLng: null,
            geoZoom: null,
            hasMapChanged: false,
        };
    },
    methods: {
        onCenterChanged() {
            this.hasMapChanged = true;
        },
        toggleCities() {
            this.showAllCities = !this.showAllCities;
        },
        toggleCounties() {
            this.showAllCounties = !this.showAllCounties;
        },
        resetMap() {
            this.geoLat = null;
            this.geoLng = null;
            this.geoBoundaryIndexId = '';
            this.hasMapChanged = false;
            this.$refs.map.resetMapPosition();
        },
        switchMap(boudaryIndexId, lat, lng) {
            if (lat && lng) {
                this.geoLat = lat;
                this.geoLng = lng;
            }
            this.hasMapChanged = false;
            this.geoBoundaryIndexId = boudaryIndexId;
        },
    },
    beforeCreate() {
        this.injectMolangDataStore({ type: 'searchState', en: enJSON, es: esJSON });
    },
    mounted() {
        if (window.innerWidth > window.innerHeight) {
            this.loadMap = true;
        }

        if (!this.loadMap) {
            const handleResize = () => {
                if (window.innerWidth > window.innerHeight && !this.loadMap) {
                    setTimeout(() => {
                        this.loadMap = true;
                        // Remove the event listener once loadMap is set to true
                        window.removeEventListener('resize', handleResize);
                    }, 500);
                }
            };

            window.addEventListener('resize', handleResize);
        }
    },
};
